// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.step-indicator {
  width: 80%;
  margin-left: 10%;
}

.main-div {
  margin-left: 12.25%;
  margin-right: 12.25%;
  margin-top: 20px;
  margin-bottom: 20px;
}
@media (max-width: 1024px) {
  .main-div {
    margin-left: 5%;
    margin-right: 5%;
  }
}

.review-heading {
  font-size: 32px;
  color: #000000;
  opacity: 1;
  float: left;
}
@media (max-width: 1024px) {
  .review-heading {
    font-size: 24px;
    line-height: 25px;
  }
}

.flex-container {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
}

.flex-item {
  padding: 5px;
  width: 600px;
  min-width: 320px;
}

.submitting {
  height: 50px;
  margin-left: 45%;
  width: 50px;
}

#error-main-container, #flex-container-spinner {
  width: 78%;
  margin-left: 11%;
}

.review-info {
  width: 100%;
  float: left;
  margin-top: 2%;
  margin-bottom: 2%;
}

.review-blocks {
  display: inline-block;
  margin-right: 10%;
}

.review-block-heading {
  font-size: 16px;
  color: #000000;
  opacity: 1;
  text-align: left;
}

.review-block-value {
  font-size: 24px;
  color: #000000;
  opacity: 1;
  text-align: left;
}

.contact-heading {
  margin-top: 2%;
  margin-bottom: 2%;
  font-size: 24px;
  color: #000000;
  opacity: 1;
  text-align: left;
}

.contact-section {
  width: 100%;
}

.added-links {
  display: inline-block;
}

.phone-field, .email-field {
  margin-bottom: 10px;
}

.contact-fields {
  margin-bottom: 10px;
  width: 40%;
}

.ctn-heading {
  font-size: 24px;
  color: #000000;
  opacity: 1;
  text-align: left;
}

.notification-heading {
  font-size: 24px;
  color: #000000;
  opacity: 1;
  text-align: left;
}

.notification-section, .ctn-section {
  margin-top: 2%;
}

.notification-type {
  width: 40%;
}

.ctn-file-name {
  width: 40%;
}

.acknowledgement-sub-section {
  display: flexbox;
  background-color: #f2f2f2;
}

.acknowledgement-section {
  background-color: transparent;
}

.acknowledgement-heading {
  font-size: 24px;
  color: #000000;
  opacity: 1;
  padding: 15px 15px 15px 15px;
  margin-bottom: 0px;
}

.acknowledgement-description {
  font-size: 16px;
  color: #000000;
  opacity: 1;
  padding: 5px 15px 5px 15px;
  margin-bottom: 0px;
}

.confirm-section {
  padding: 15px 15px 15px 15px;
}

#requestEnrollment {
  float: right;
  font-size: 17px;
}

a {
  color: #1483d9;
  cursor: pointer;
}

a:hover {
  text-decoration: underline;
}

#cancel-link {
  float: right;
  margin-right: 20px;
  margin-top: 15px;
  font-size: 18px;
}

.submit-section {
  height: 50px;
}

.labels-inline {
  display: inline-block;
}

.bold-heading {
  font-weight: 600;
}

.offer-heading {
  font-size: 16px;
  margin-bottom: 10px;
}

.bullet-points {
  list-style: disc;
}

ul {
  padding-left: 20px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/signup-fiveg/review/review.component.scss"],"names":[],"mappings":"AAAA;EACI,UAAA;EACA,gBAAA;AACJ;;AACA;EACI,mBAAA;EACA,oBAAA;EACA,gBAAA;EACA,mBAAA;AAEJ;AADI;EALJ;IAMQ,eAAA;IACA,gBAAA;EAIN;AACF;;AAIA;EACI,eAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;AADJ;AAEI;EALJ;IAMQ,eAAA;IACA,iBAAA;EACN;AACF;;AACA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AAEJ;;AACE;EACE,YAAA;EACA,YAAA;EACA,gBAAA;AAEJ;;AACE;EACE,YAAA;EACA,gBAAA;EACA,WAAA;AAEJ;;AAAE;EACI,UAAA;EACA,gBAAA;AAGN;;AADA;EACI,WAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;AAIJ;;AAFA;EACI,qBAAA;EACA,iBAAA;AAKJ;;AAHA;EACI,eAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;AAMJ;;AAJA;EACI,eAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;AAOJ;;AALA;EACI,cAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;AAQJ;;AANA;EACI,WAAA;AASJ;;AAPA;EACI,qBAAA;AAUJ;;AAPA;EACI,mBAAA;AAUJ;;AARA;EACI,mBAAA;EACA,UAAA;AAWJ;;AATA;EACI,eAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;AAYJ;;AAVA;EACI,eAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;AAaJ;;AAXA;EACI,cAAA;AAcJ;;AAZA;EACI,UAAA;AAeJ;;AAbA;EACI,UAAA;AAgBJ;;AAdA;EACI,gBAAA;EACA,yBAAA;AAiBJ;;AAfA;EACI,6BAAA;AAkBJ;;AAhBA;EACI,eAAA;EACA,cAAA;EACA,UAAA;EACA,4BAAA;EACA,kBAAA;AAmBJ;;AAjBA;EACI,eAAA;EACA,cAAA;EACA,UAAA;EACA,0BAAA;EACA,kBAAA;AAoBJ;;AAlBA;EACI,4BAAA;AAqBJ;;AAnBA;EACI,YAAA;EACA,eAAA;AAsBJ;;AApBA;EACI,cAAA;EACA,eAAA;AAuBJ;;AArBA;EACI,0BAAA;AAwBJ;;AAtBA;EACI,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAyBJ;;AAvBA;EACI,YAAA;AA0BJ;;AAxBA;EACI,qBAAA;AA2BJ;;AAxBA;EACI,gBAAA;AA2BJ;;AAxBA;EACI,eAAA;EACA,mBAAA;AA2BJ;;AAxBA;EACI,gBAAA;AA2BJ;;AAxBA;EACI,kBAAA;AA2BJ","sourcesContent":[".step-indicator {\n    width: 80%;\n    margin-left: 10%;\n}\n.main-div {\n    margin-left: 12.25%;\n    margin-right: 12.25%;\n    margin-top: 20px;\n    margin-bottom: 20px;\n    @media (max-width: 1024px) {\n        margin-left: 5%;\n        margin-right: 5%;\n     }\n}\n// @media(max-width: 500px) {\n//     .main-div {\n//         margin-left: 2.25%;\n//         margin-right: 2.25%;\n//     }\n// }\n.review-heading {\n    font-size: 32px;\n    color: #000000;\n    opacity: 1;\n    float: left;\n    @media(max-width: 1024px) {\n        font-size: 24px;\n        line-height: 25px;\n    }\n}\n.flex-container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: row;\n  }\n  \n  .flex-item {\n    padding: 5px;\n    width: 600px;\n    min-width: 320px;\n  }\n  \n  .submitting {\n    height: 50px;\n    margin-left: 45%;\n    width: 50px;\n  }\n  #error-main-container, #flex-container-spinner {\n      width: 78%;\n      margin-left: 11%;\n  }\n.review-info {\n    width: 100%;\n    float: left;\n    margin-top: 2%;\n    margin-bottom: 2%;\n}\n.review-blocks {\n    display: inline-block;\n    margin-right: 10%;\n}\n.review-block-heading {\n    font-size: 16px;\n    color: #000000;\n    opacity: 1;\n    text-align: left;\n}\n.review-block-value {\n    font-size: 24px;\n    color: #000000;\n    opacity: 1;\n    text-align: left;\n}\n.contact-heading {\n    margin-top: 2%;\n    margin-bottom: 2%;\n    font-size: 24px;\n    color: #000000;\n    opacity: 1;\n    text-align: left;\n}\n.contact-section {\n    width: 100%;\n}\n.added-links {\n    display: inline-block;\n    // width: 40%;\n}\n.phone-field, .email-field {\n    margin-bottom: 10px;\n}\n.contact-fields {\n    margin-bottom: 10px;\n    width: 40%;\n}\n.ctn-heading {\n    font-size: 24px;\n    color: #000000;\n    opacity: 1;\n    text-align: left;\n}\n.notification-heading {\n    font-size: 24px;\n    color: #000000;\n    opacity: 1;\n    text-align: left;\n}\n.notification-section, .ctn-section {\n    margin-top: 2%;\n}\n.notification-type {\n    width: 40%;\n}\n.ctn-file-name {\n    width: 40%;\n}\n.acknowledgement-sub-section {\n    display: flexbox;\n    background-color: #f2f2f2;\n}\n.acknowledgement-section {\n    background-color: transparent;\n}\n.acknowledgement-heading {\n    font-size: 24px;\n    color: #000000;\n    opacity: 1;\n    padding: 15px 15px 15px 15px;\n    margin-bottom: 0px;\n}\n.acknowledgement-description {\n    font-size: 16px;\n    color: #000000;\n    opacity: 1;\n    padding: 5px 15px 5px 15px;\n    margin-bottom: 0px;\n}\n.confirm-section {\n    padding: 15px 15px 15px 15px;\n}\n#requestEnrollment {\n    float: right;\n    font-size: 17px;\n}\na {\n    color: #1483d9;\n    cursor: pointer;\n}\na:hover {\n    text-decoration: underline;\n}\n#cancel-link {\n    float: right;\n    margin-right: 20px;\n    margin-top: 15px;\n    font-size: 18px;\n}\n.submit-section {\n    height: 50px;\n}\n.labels-inline {\n    display: inline-block;\n}\n\n.bold-heading {\n    font-weight: 600;\n}\n\n.offer-heading {\n    font-size: 16px;\n    margin-bottom: 10px;\n}\n\n.bullet-points {\n    list-style: disc;\n}\n\nul {\n    padding-left: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
